import React, { useEffect, useState } from "react";
import "./erxMiniMapping.scss";
import { ERXComponents, ERXComponentsHeader } from "../ERXConstants/constants";
import { Divider } from "@material-ui/core";
import TitleWithBorder from "../common/TitleWithBorder";
import {
  getFinalCustomSectionList,
  getFinalDiagnosisList,
  getFinalDrugsList,
  getFinalInvestigationsAndInstructionsList,
  getFinalObstetricCalculatorDetails,
  getFinalPatientHistoryList,
  getFinalReportList,
  getFinalVitalList,
} from "../helper";

const ERXMiniMapping = (props) => {
  const {
    erxComponents,
    vitalsList,
    patient_history_and_complaints,
    diagnosisList,
    reportList,
    drugList,
    followUpDate,
    followUp,
    doctorNote,
    updatedGender,
    obstetricHistoryList,
    customSection,
    obstetricDetails,
    doctorSpecialization,
    allowedObstetricDetailsSpecializations,
    handleRedirect,
  } = props;

  const [detailsList, setDetailsList] = useState(
    JSON.parse(JSON.stringify(ERXComponents))
  );

  // Lifecycle Methods ===>

  useEffect(() => {
    let list = [...erxComponents];
    list.forEach((ele) => {
      if (ele.name.includes("CustomSection")) {
        let ind = erxComponents.findIndex((comp) => comp.name === ele.name);
        if (ind > -1) {
          ele.show = erxComponents[ind].show;
          if (ele.name.includes("CustomSection")) {
            ele.showInDetails = customSection?.value?.hasOwnProperty(ele.name);
          }
        }
      } else if (ele.title === ERXComponentsHeader.OBSTETRIC_CALCULATOR) {
        ele.showInDetails =
          updatedGender?.toLowerCase() === "female" &&
          allowedObstetricDetailsSpecializations.includes(doctorSpecialization);
      } else {
        let ind = erxComponents.findIndex((comp) => comp.title === ele.title);
        if (ind > -1) {
          ele.show = erxComponents[ind].show;
        }
      }
    });
    setDetailsList([...list]);
  }, [erxComponents, updatedGender, doctorSpecialization]);

  // <===

  // Actions ===>

  // <===

  // Helper Methods ===>

  const getPatientHistoryTitle = (patientHistory, sectionName) => {
    return `${
      sectionName === "obstetric_history" ? patientHistory?.title + ": " : ""
    }${patientHistory.value}
    ${
      patientHistory.painScaleData?.pain_scale
        ? " - " + patientHistory.painScaleData?.pain_scale
        : ""
    }
    ${
      patientHistory.painScaleData?.since
        ? " - " + patientHistory.painScaleData?.since
        : ""
    }
    ${
      patientHistory.painScaleData?.area
        ? " - " + patientHistory.painScaleData?.area
        : ""
    }`;
  };

  const displaySectionTitle = (item) => {
    return item.title;
  };

  // <===

  // Display UI ===>

  const displayERXPreview = () => {
    return (
      <>
        {displayPreviewHeader()}
        {<Divider style={{ backgroundColor: "#E5E5E5" }} />}
        {displayPreviewDetails()}
      </>
    );
  };

  const displayPreviewHeader = () => {
    return (
      <div className="erx-preview-header">
        <div className="d-flex ai-center">
          <div className="erx-preview-header-value1">Mini Map</div>
        </div>
      </div>
    );
  };

  const displayPreviewDetails = () => {
    return (
      <div className="erx-preview-details">
        {detailsList.map((item) => (
          <div key={item.id}>
            {item.showInDetails && (
              <>
                <div className="erx-preview-details-header">
                  <div className="erx-preview-details-header-value">
                    {displaySectionTitle(item)}
                  </div>
                  <div
                    className="erx-preview-details-header-edit-btn"
                    style={{
                      color: item.show ? "" : "#C1C1C1",
                      cursor: item.show ? "" : "not-allowed",
                    }}
                    onClick={() => (item.show ? handleRedirect(item) : "")}
                  >
                    Edit
                  </div>
                </div>
                <Divider style={{ backgroundColor: "#E5E5E5" }} />
                {displayDetailsContent(item)}
              </>
            )}
          </div>
        ))}
      </div>
    );
  };

  const displayDetailsContent = (item) => {
    return (
      <>
        {item.show && (
          <>
            {item.title === ERXComponentsHeader.VITALS &&
              displayVitalsDetails()}
            {item.title ===
              ERXComponentsHeader.PATIENT_HISTORY_AND_COMPLAINTS &&
              displayHistoryComplaintsDetails(item)}
            {item.title === ERXComponentsHeader.DIAGNOSIS &&
              displayDiagnosisDetails()}
            {item.title ===
              ERXComponentsHeader.PATIENT_OR_REPORTS_EXAMINATION &&
              displayReportsDetails()}
            {item.title === ERXComponentsHeader.DRUG_OR_MEDICINES &&
              displayMedicinesDetails()}
            {item.title === ERXComponentsHeader.PATIENT_FOLLOWUP &&
              displayFollowupDetails()}
            {item.title === ERXComponentsHeader.DOCTOR_NOTES &&
              displayDoctorNotesDetails()}
            {item.title === ERXComponentsHeader.SUGGESTED_INVESTIGATION &&
              displaySuggestedInvestigationDetails()}
            {item.name.includes("CustomSection") &&
              displayCustomSectionDetails(item.name)}
            {item.title === ERXComponentsHeader.OBSTETRIC_CALCULATOR &&
              displayObstetricCalculatorDetails()}
          </>
        )}
      </>
    );
  };

  const displayVitalsDetails = () => {
    let list = getFinalVitalList(vitalsList, updatedGender);
    let display = list.length === 0;
    return (
      <>
        {!display && (
          <div
            className="erx-preview-details-content erx-preview-wrapped-content"
            style={{ alignItems: "baseline", paddingBottom: "0" }}
          >
            {list.map((item, ind) => (
              <div key={ind} className="col-4 pl-0">
                <div
                  className="erx-preview-diagnosis-description"
                  style={{ color: "#ACACAC", marginBottom: "5px" }}
                >
                  {item.name}
                </div>
                <div
                  className="erx-preview-history-header"
                  style={{ overflowWrap: "anywhere", marginBottom: "15px" }}
                >
                  {item.value} {item.unit}
                </div>
              </div>
            ))}
          </div>
        )}
      </>
    );
  };

  const displayHistoryComplaintsDetails = (item) => {
    let list = getFinalPatientHistoryList(
      patient_history_and_complaints?.value,
      obstetricHistoryList?.value,
      updatedGender,
      item
    );
    let display = list.length === 0;
    return (
      <>
        {!display && (
          <div className="erx-preview-details-content">
            {list.map((li) => (
              <div key={li.id} className="erx-preview-history-cont">
                <div className="erx-preview-history-header">
                  {li.inputLabel?.replace("*", "")}
                </div>
                <div className="erx-preview-wrapped-content">
                  {li.value.map((patientHistory, ind) => (
                    <TitleWithBorder
                      key={ind}
                      title={getPatientHistoryTitle(patientHistory, li?.name)}
                    />
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </>
    );
  };

  const displayDiagnosisDetails = () => {
    let list = getFinalDiagnosisList(diagnosisList?.value);
    let display = list.length === 0;
    return (
      <>
        {!display && (
          <div className="erx-preview-details-content">
            {list.map((item, ind) => (
              <div key={ind} className="erx-preview-diagnosis-cont">
                {item.title && item.title.trim().length > 0 && (
                  <TitleWithBorder title={item.title} />
                )}
                <div className="erx-preview-diagnosis-description">
                  {item.description}
                </div>
              </div>
            ))}
          </div>
        )}
      </>
    );
  };

  const displayReportsDetails = () => {
    let list = getFinalReportList(reportList?.value);
    let display = list.length === 0;
    return (
      <>
        {!display && (
          <div className="erx-preview-details-content">
            {list.map((item, ind) => (
              <div key={ind} className="erx-preview-diagnosis-cont">
                {item.title && item.title.trim().length > 0 && (
                  <TitleWithBorder title={item.title} />
                )}
                <div className="erx-preview-diagnosis-description">
                  {item.description}
                </div>
              </div>
            ))}
          </div>
        )}
      </>
    );
  };

  const displayMedicinesDetails = () => {
    let list = getFinalDrugsList(drugList?.value);
    let display = list.length === 0;
    return (
      <>
        {!display && (
          <div className="erx-preview-details-content">
            {list.map((item, ind) => (
              <div
                key={ind}
                style={{
                  borderBottom:
                    ind !== list?.length - 1 ? "1px solid #E5E5E5" : "",
                  paddingTop: ind === 0 ? "" : "15px",
                  paddingBottom: ind !== list?.length - 1 ? "5px" : "",
                }}
              >
                {(item.drug?.trim() ||
                  item.frequency_extended?.title?.trim() ||
                  item.frequency_exyended?.details?.trim() ||
                  item.duration?.trim()) &&
                  item?.id && (
                    <div className="row mx-0">
                      <div
                        className="col-4 px-0 erx-preview-history-header"
                        style={{ fontWeight: "normal" }}
                      >
                        {item.drug}
                      </div>
                      <div className="col-2 px-0 erx-preview-history-header">
                        {item.quantity} {item.unit}
                        {item.frequency_extended?.title?.trim() &&
                          ` (${item.frequency_extended?.title
                            ?.trim()
                            ?.substr(0, 5)}${
                            item.frequency_extended?.title?.trim().length > 5
                              ? "..."
                              : ""
                          })`}
                      </div>
                      <div className="col-4 erx-preview-history-header">
                        {item.frequency_extended?.details}
                      </div>
                      <div className="col-2 px-0 erx-preview-history-header">
                        {item.duration}
                      </div>
                    </div>
                  )}
                {item.instructions?.trim() && (
                  <div
                    className="erx-preview-history-header"
                    style={{ fontWeight: "normal" }}
                  >
                    {item.instructions}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </>
    );
  };

  const displayFollowupDetails = () => {
    let display = !followUpDate?.value?.trim();
    return (
      <>
        {!display && (
          <div className="erx-preview-details-content">
            {followUpDate?.value?.trim() && (
              <>
                <div
                  className="erx-preview-history-header"
                  style={{
                    color: "#C1C1C1",
                    marginBottom: "5px",
                    fontWeight: "normal",
                  }}
                >
                  Next Follow-Up Date
                </div>
                <div className="erx-preview-history-header">
                  {followUpDate?.value}
                </div>
              </>
            )}
          </div>
        )}
      </>
    );
  };

  const displayDoctorNotesDetails = () => {
    let display = !doctorNote?.value?.trim();
    return (
      <>
        {!display && (
          <div className="erx-preview-details-content">
            <div
              className="erx-preview-diagnosis-description"
              style={{ overflowWrap: "anywhere" }}
            >
              {doctorNote?.value}
            </div>
          </div>
        )}
      </>
    );
  };

  const displaySuggestedInvestigationDetails = () => {
    let list = getFinalInvestigationsAndInstructionsList(followUp.value);
    let display = list.length === 0;
    return (
      <>
        {!display && (
          <div className="erx-preview-details-content">
            {list.map(
              (item, ind) =>
                item.value?.length !== 0 && (
                  <div key={ind}>
                    <div
                      className="erx-preview-history-header"
                      style={{
                        color: "#C1C1C1",
                        marginBottom: "5px",
                        fontWeight: "normal",
                      }}
                    >
                      {item.inputLabel}
                    </div>
                    <div className="erx-preview-history-header">
                      {item.value.map((ele) => ele.value).join(", ")}.
                    </div>
                  </div>
                )
            )}
          </div>
        )}
      </>
    );
  };

  const displayCustomSectionDetails = (name) => {
    let list = Object.keys(customSection?.value).includes(name)
      ? getFinalCustomSectionList(customSection?.value[name])
      : [];
    let display = list.length === 0;
    return (
      <>
        {!display && (
          <div className="erx-preview-details-content">
            {list.map((item, index) => (
              <div key={index} className="erx-preview-history-cont">
                <div className="erx-preview-history-header">
                  {item.field_title}
                </div>
                <div className="erx-preview-wrapped-content">
                  {item.value.map((ele, ind) => (
                    <TitleWithBorder key={ind} title={ele.title} />
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </>
    );
  };

  const displayObstetricCalculatorDetails = () => {
    let list = getFinalObstetricCalculatorDetails(
      obstetricDetails,
      updatedGender
    );
    let display = list.length === 0;
    return (
      <>
        {!display && (
          <div className="erx-preview-details-content">
            {list.map((item) => (
              <div key={item.id} className="erx-preview-history-cont">
                <div className="erx-preview-history-header">{item.title}</div>
                {item.title === "Note" ? (
                  <div className="erx-preview-diagnosis-description">
                    {item?.value}
                  </div>
                ) : (
                  <div className="erx-preview-wrapped-content">
                    {item.value.map((details, ind) => (
                      <TitleWithBorder key={ind} title={details.title} />
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </>
    );
  };

  // <===

  return <div className="erx-preview-cont">{displayERXPreview()}</div>;
};

export default ERXMiniMapping;
